import * as React from 'react';
import './styles.scss';
import { ErrorPanel } from '../../../atoms/error-panel/error-panel';

export interface IErrorList {
  [id: string]: { message: string; };
}

export interface ErrorListProps {
  errors?: IErrorList;
}

export const ErrorList: React.FunctionComponent<ErrorListProps> = ({ errors, children }) => {

  const errorList = errors && (
    <ul className="error-panel-list">
      {Object.keys(errors).map((key: string) =>
        <li key={key}>{errors[key].message}</li>
      )}
    </ul>)

  return (
    <>
      {errors && Object.keys(errors).length > 0 &&
        <>
          <ErrorPanel>
            {children}
            {errorList}
          </ErrorPanel>
        </>
      }
    </>
  )
};